import React from 'react'

function ScrollToTop() {
    return (
        <div>ScrollToTop</div>
    )
}

export default ScrollToTop